export default "__VITE_ASSET__Cz6gxXCA__"